// extracted by mini-css-extract-plugin
export default {"component":"Switch_component__e6hiM","customSwitch":"Switch_customSwitch__PZZHf","sliderRound":"Switch_sliderRound__Gz9Vf"};